import {AppUrls} from 'shared/config/model/urls';

import {MouseEvent, useCallback, useState} from 'react';
import {generatePath, useLocation, useNavigate} from 'react-router-dom';

import {isHttpMonitorDetailsPath} from 'features/http/lib/httpIncidentView';
import IHttpIncident from 'features/http/model/HttpIncident/IHttpIncident';

export interface IUseHttpIncidentRow {
    isModalOpen: boolean,
    handleClose: () => void,
    onTrClick: (_event: MouseEvent<HTMLTableRowElement>) => void,
    onButtonClick: (_event: MouseEvent<HTMLTableCellElement>) => void,
}

export const useHttpIncidentRow = (item: IHttpIncident): IUseHttpIncidentRow => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();
    const {pathname} = useLocation();
    const isMonitorDetailsPage = isHttpMonitorDetailsPath(pathname);

    const handleClose = useCallback(() => setIsModalOpen(false), []);

    const onTrClick = useCallback((event: MouseEvent<HTMLTableRowElement>) => {
        event.stopPropagation();
        setIsModalOpen(true);
    }, []);

    const onButtonClick = useCallback((event: MouseEvent<HTMLTableCellElement>) => {
        event.stopPropagation();
        event.preventDefault();
        if (isMonitorDetailsPage) {
            setIsModalOpen(true);
        } else {
            navigate(generatePath(AppUrls.HTTP_MONITOR_DETAILS, {monitorId: item.monitor.uuid}));
        }
    }, [navigate, item.monitor.uuid, isMonitorDetailsPage]);

    return {isModalOpen, handleClose, onTrClick, onButtonClick};
};

export default useHttpIncidentRow;
